import  { Variable } from "@eusoft/webapp-ui";
import "./ColorBox.scss";


interface IColorBoxOptions {
    color: string;
}

export function ColorBox(options: IColorBoxOptions) {

    return <i className="color-box">
        <Variable name="color" value={options.color}/>
    </i>
}

